<template>
    <section>
        <header-view></header-view>
        <div class="container-fluid">
            <router-view></router-view>
        </div>
        <footer-view></footer-view>
    </section>
</template>

<script>
    import Header from "@/components/layouts/Header";
    import Footer from "@/components/layouts/Footer";

    export default {
        name: "MainLayout",
        components: {
            "header-view": Header,
            "footer-view": Footer
        }
    };
</script>

<style scoped>
    .container-fluid {
        min-height: calc(100vh - 293px);
    }    
</style>


// WEBPACK FOOTER //
// src/components/layouts/Main.vue